"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createQueryConfig = void 0;
var normalizr_1 = require("normalizr");
/**
 * Create redux-query transform function from config
 * @param config
 */
var createTransform = function (config) { return function (responseBody, responseText) {
    var _a;
    if (config.onResolve) {
        config.onResolve(responseBody || responseText);
    }
    if (config.onDeserialize && typeof config.onDeserialize === 'function') {
        return config.onDeserialize(responseBody, responseText);
    }
    if ((config.onDeserialize && config.onDeserialize instanceof normalizr_1.schema.Entity) ||
        config.onDeserialize instanceof normalizr_1.schema.Array ||
        config.onDeserialize instanceof normalizr_1.schema.Object ||
        config.onDeserialize instanceof normalizr_1.schema.Union ||
        config.onDeserialize instanceof normalizr_1.schema.Values) {
        return normalizr_1.normalize(responseBody, config.onDeserialize).entities;
    }
    var data = responseBody || responseText;
    return typeof config.entity === 'string'
        ? (_a = {},
            _a[config.entity] = data,
            _a) : data;
}; };
/**
 *
 * @todo migrate to ImmutableJS for performance improvements.
 * @param preEntityState
 * @param nextEntityState
 */
var updateFunction = function (preEntityState, nextEntityState) { return nextEntityState; };
/**
 * Create redux-query update:IUpdate from config.
 * @param config
 */
var createUpdate = function (config) {
    var _a;
    return config.entity instanceof Array
        ? config.entity.reduce(function (acc, entity) {
            var _a;
            return (__assign(__assign({}, acc), (_a = {}, _a[entity] = updateFunction, _a)));
        }, {})
        : !!config.entity
            ? (_a = {},
                _a[config.entity] = updateFunction,
                _a) : {};
};
/**
 * Consider using ImmutableJS or Immer to improve performance when merging data structures.
 * @param config
 */
exports.createQueryConfig = function (config) { return (__assign(__assign({}, config), { body: config.onSerialize ? config.onSerialize(config.body) : config.body, transform: config.transform
        ? config.transform
        : createTransform(config), update: config.update
        ? config.update
        : createUpdate(config), url: "" + (config.host ? config.host + config.url : config.url) })); };
//# sourceMappingURL=HttpQuery.js.map